import React from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

const VARIANTS = {
  primary: "bg-coral text-white",
  secondary: "bg-lime text-sea-deep",
  sky: "bg-sky-dark text-white",
  sunny: "bg-sunny text-sea-deep",
  white: "bg-white text-sea-deep",
  destructive: "bg-destructive text-white",
  ghost: "bg-white/70 text-sea-deep border-sea/20",
};

const SIZES = {
  sm: "px-5 py-2 text-sm",
  md: "px-7 py-3 text-base",
  lg: "px-9 py-4 text-lg",
};

export const PillButton = React.forwardRef(function PillButton(
  { children, variant = "primary", size = "md", className, as: As, ...props },
  ref
) {
  const Comp = As ? motion(As) : motion.button;
  return (
    <Comp
      ref={ref}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.94 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
      className={cn(
        "inline-flex items-center justify-center gap-2 font-display font-extrabold rounded-full border-4 border-white shadow-playful focus:outline-none focus-visible:ring-4 focus-visible:ring-sky/60 disabled:opacity-60 disabled:pointer-events-none select-none",
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    >
      {children}
    </Comp>
  );
});
